import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { UploadLinkInfo } from "../model/upload/uploadLink";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ExternalFileUploadService {
  constructor(private http: HttpClient) {}

  findUploadLinkData(urlIdentifier: string): Observable<UploadLinkInfo> {
    return this.http.get<UploadLinkInfo>(
      `${environment.baseUrl}/api/public/upload/findUploadlink/${urlIdentifier}`
    );
  }
}
